// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_l1-1";
export var quotedThread = "_l1-0";